import React from "react";

import { navigation } from "@/utils/navigation";
import { useTranslation } from "next-i18next";

import DefaultLink from "@/components/elements/link/DefaultLink";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Container,
  Typography,
  useTheme
} from "@mui/material";

import ArrowBottomIcon from "~public/icons/Arrow Bottom/Arrow Bottom.svg";

export const FAQContentSection = (): JSX.Element => {
  const { t } = useTranslation("faq");
  const theme = useTheme();
  return (
    <Container>
      <Typography
        variant={"h1"}
        textAlign={"center"}
        sx={{
          pt: 1,
          mb: 2,
          fontSize: { xs: 24, md: 48 },
          textAlign: { xs: "center", md: "start" },
          whiteSpace: { xs: "pre-line", md: "normal" },
          fontWeight: { md: 400 }
        }}
        color={theme.palette.primary.main}>
        {t("title")}
      </Typography>
      {[1, 2, 3, 4, 5, 6, 7].map(index => (
        <Accordion
          disableGutters
          key={index}
          sx={{
            boxShadow: "none",
            borderTop: `1px solid ${theme.palette.gray.main}`,
            color: theme.palette.primary.main
          }}>
          <AccordionSummary
            expandIcon={<ArrowBottomIcon style={{ fontSize: 12 }} />}
            aria-controls={`panel${index}__content`}
            id={`panel${index}__header`}
            sx={{
              px: 0,
              my: { xs: 0.375, md: "6px" },
              "& path": {
                fill: theme.palette.primary.main
              },
              "& > .Mui-expanded": {
                m: "12px 0"
              }
            }}>
            <Typography
              fontSize={16}
              sx={{ fontSize: { xs: 16, md: 20 } }}
              fontWeight={300}>
              {t(`item${index}Title`)}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ px: 0 }}>
            <Typography
              fontWeight={300}
              color={theme.palette.primary.light}
              sx={{
                fontSize: { md: 18 }
              }}
              whiteSpace={"pre-line"}>
              {t(`item${index}Description`)}
            </Typography>
            {index === 6 && (
              <DefaultLink href={"/about"}>{t("item6Link")}</DefaultLink>
            )}
          </AccordionDetails>
        </Accordion>
      ))}
      <Typography
        fontSize={16}
        color={theme.palette.primary.main}
        sx={{ mt: 2 }}>
        {t("cantFind")}{" "}
        <DefaultLink
          href={navigation.contactUs}
          fontSize={16}
          color={"inherit"}>
          {t("contactUs")}
        </DefaultLink>
      </Typography>
    </Container>
  );
};
